<template>
  <div
    class="announcement-banner"
    :style="[
      `--ab-background-color: ${backgroundColour}`,
      `--ab-text-color: ${textColour}`,
    ]"
  >
    <div
      id="announcementBannerCarousel"
      ref="carouselContainer"
      class="announcement-banner__carousel splide"
      role="complementary"
      :aria-label="$string('general.site_header.announcement_banner')"
      js-carousel="announcement-banner"
    >
      <div class="splide__track">
        <div class="splide__list text-center">
          <p
            v-for="(announcement, index) of announcements"
            :key="`banner-${index}`"
            class="announcement-banner__text splide__slide text-heading-2xs"
            v-html="getAnnouncementText(announcement)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Announcement banner (announcement-banner)
 * -----------------------------------------------------------------------------
 * This is an slider announcement banner used by the site header.
 *
 * @param {Array} announcements - Banner items.
 * @param {String} backgroundColour - Banner background colour.
 * @param {Number} bannerSpeed - Carousel change speed.
 * @param {String} textColour - Banner text colour.
 *
 */
import Carousel from '~/apis/carousel'

export default {
  name: 'AnnouncementBanner',

  props: {
    announcements: {
      type: Array,
      default: () => [],
    },
    backgroundColour: {
      type: String,
      default: '#000000',
    },
    bannerSpeed: {
      type: Number,
      default: 2500,
    },
    textColour: {
      type: String,
      default: '#ffffff',
    },
  },

  data() {
    return {
      selectors: {
        container: '[js-carousel="announcement-banner"]',
      },
    }
  },

  mounted() {
    this.createCarousel()
  },

  methods: {

    /**
     * Get announcement text.
     * @param {Object} announcement - Announcement block object.
     * @returns {String}
     */
    getAnnouncementText(announcement) {
      if (announcement.widget) {
        return announcement.widget
      }

      return announcement.text
        ? announcement.text.replace('<a', '<a class="text-heading-2xs"')
        : announcement.text
    },

    /**
     * Main carousel constructor function
     */
    createCarousel() {
      const container = this.$refs.carouselContainer

      if (!container) {
        return
      }

      const interval = Number(this.bannerSpeed * 1000)

      Carousel(
        this.selectors.container,
        {
          type: 'fade',
          rewind: true,
          autoplay: true,
          interval,
        },
      ).mount()
    },
  },
}
</script>
